import {
  LOAD_PROGRAMMES_DATA,
  LOAD_PROGRAMMES_DATA_SUCCESS,
  LOAD_TERMS_DATA_SUCCESS,
  LOAD_TERMS_DATA,
  LOAD_COURSES_DATA,
  LOAD_COURSES_DATA_SUCCESS,
  LOAD_ROLES_DATA,
  LOAD_ROLES_DATA_SUCCESS,
  LOAD_USER_DATA,
  LOAD_USER_DATA_SUCCESS,
  CLEAR_COURSES_DATA,
  SELECTED_TERM_UPDATE,
  UPDATE_FILTERED_COURSE_DATA,
  SIS_POST_ENROLLMENTS,
  SIS_POST_ENROLLMENTS_SUCCESS,
  SELECTED_PROGRAMME_UPDATE,
  UPDATE_STEUP_PROGRESS,
  UPDATE_USERE_EMAIL_LIST,
  SIS_STATUS,
  SIS_STATUS_SUCCESS,
  CLEAR_SUMMERY_COURSES,
  ACCESS_TOKEN,
  UPDATE_CSV_ACTION,
  LOAD_PROGRAMMES_DATA_BY_ID,
  LOAD_PROGRAMMES_DATA_BY_ID_SUCCESS,
  SELECTED_SUB_ACCOUNT_UPDATE,
  LOAD_COURSES_DATA_START,
  LOAD_SECTION_DATA,
  LOAD_SECTION_DATA_SUCCESS,
  UPDATE_SECTION_USER_DATA
} from '../constants/action-types'

const initialState = {
  terms: { data: [], loading: true },
  courses: { data: [], loading: false },
  summery: { courses: [], users: [], data: [], userstext: '', terms: [] },
  users: { data: [], loading: true },
  selectedTerms: { data: [] },
  selectedSubAccount: { data: [] },
  selectedProgramme: { data: [] },
  postEnrollments: { data: [], loading: true },
  setupProgress: 0,
  roles: { data: [], loading: true },
  sis_status: { data: [], id: 0, workflow_state: '', loading: true },
  access_token: '',
  csvActionType: '',
  programmesByID: { data: [], loading: true },

  courseSection: { data: [], loading: true },

  courseSectionUserData: { data: [] }
}

function CourseLevelAdmin(state = initialState, action) {
  if (action.type === LOAD_PROGRAMMES_DATA_SUCCESS) {
    return {
      ...state,
      ...{ programmes: { data: action.payload, loading: false } }
    }
  }

  if (action.type === LOAD_PROGRAMMES_DATA) {
    return {
      ...state,
      ...{ programmes: { data: [{ id: 0, name: 'Loading..' }], loading: true } }
    }
  }

  if (action.type === LOAD_TERMS_DATA_SUCCESS) {
    let terms = [...state.terms.data.concat(action.payload.enrollment_terms)]

    if (action.payload.loading === false) {
      terms = terms.map((option) => {
        const firstLetter = option.name[0].toUpperCase()

        return {
          firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
          ...option
        }
      })

      terms = terms.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))
    }

    return {
      ...state,
      ...{ terms: { data: terms, loading: action.payload.loading } }
    }
  }

  if (action.type === LOAD_TERMS_DATA) {
    return {
      ...state,
      ...{ terms: { data: [], loading: true } }
    }
  }

  if (action.type === SELECTED_TERM_UPDATE) {
    return {
      ...state,
      ...{ selectedTerms: { data: action.payload } }
    }
  }

  if (action.type === SELECTED_SUB_ACCOUNT_UPDATE) {
    return {
      ...state,
      ...{ selectedSubAccount: { data: action.payload } }
    }
  }

  if (action.type === SELECTED_PROGRAMME_UPDATE) {
    return {
      ...state,
      ...{ selectedProgramme: { data: action.payload } }
    }
  }

  if (action.type === LOAD_COURSES_DATA_START) {
    return {
      ...state,
      ...{ courses: { data: [...state.courses.data], loading: action.loading } }
    }
  }

  if (action.type === LOAD_COURSES_DATA_SUCCESS) {
    // let termIds = state.selectedTerms.data.map( terms => terms.id );

    let dataAlreadySaved = state.courses.data.filter(
      (row) =>
        row.account_id === action.key.programme &&
        row.page_number === action.key.page
    )

    if (dataAlreadySaved.length === 0) {
      return {
        ...state,
        ...{
          courses: {
            data: [...state.courses.data.concat(action.payload)],
            loading: action.loading
          }
        }
      }
    } else {
      return {
        ...state,
        ...{
          courses: { data: [...state.courses.data], loading: action.loading }
        }
      }
    }
  }

  if (action.type === UPDATE_FILTERED_COURSE_DATA) {
    return {
      ...state,
      ...{ courses: { data: action.payload, loading: false } }
    }
  }

  if (action.type === CLEAR_COURSES_DATA) {
    return {
      ...state,
      ...{ courses: { data: [], loading: false } }
    }
  }

  if (action.type === LOAD_COURSES_DATA) {
    return {
      ...state,
      ...{ courses: { data: [...state.courses.data], loading: true } }
    }
  }

  if (action.type === LOAD_ROLES_DATA) {
    return {
      ...state,
      ...{ roles: { data: [{ id: 0, label: 'Loading..' }], loading: true } }
    }
  }

  if (action.type === LOAD_ROLES_DATA_SUCCESS) {
    return {
      ...state,
      ...{ roles: { data: action.payload, loading: false } }
    }
  }

  if (action.type === LOAD_PROGRAMMES_DATA_BY_ID) {
    return {
      ...state,
      ...{ programmesByID: { data: [], loading: true } }
    }
  }

  if (action.type === LOAD_PROGRAMMES_DATA_BY_ID_SUCCESS) {
    return {
      ...state,
      ...{ programmesByID: { data: action.payload, loading: false } }
    }
  }

  if (action.type === LOAD_USER_DATA_SUCCESS) {
    let i = state.users.req + 1

    let isLoading = action.key == i ? true : false

    if (action.payload.length != 0) {
      return {
        ...state,
        ...{
          users: {
            data: [...state.users.data, action.payload],
            loading: isLoading,
            req: i,
            org: action.key
          }
        }
      }
    }

    return {
      ...state,
      ...{
        users: {
          data: [...state.users.data],
          loading: isLoading,
          req: i,
          org: action.key
        }
      }
    }
  }

  if (action.type === LOAD_USER_DATA) {
    return {
      ...state,
      ...{ users: { data: [], loading: true, req: 1 } }
    }
  }

  if (action.type === SIS_POST_ENROLLMENTS || action.type === SIS_STATUS) {
    return {
      ...state,
      ...{
        sis_status: {
          data: [],
          id: state.sis_status.id,
          workflow_state: state.sis_status.workflow_state,
          loading: true
        }
      }
    }
  }

  if (
    action.type === SIS_POST_ENROLLMENTS_SUCCESS ||
    action.type === SIS_STATUS_SUCCESS
  ) {
    return {
      ...state,
      ...{
        sis_status: {
          data: [action.payload],
          id: action.payload.id,
          workflow_state: action.payload.workflow_state,
          loading: false
        }
      }
    }
  }

  if (action.type === UPDATE_STEUP_PROGRESS) {
    return {
      ...state,
      ...{ setupProgress: action.payload + 1 }
    }
  }

  if (action.type === UPDATE_USERE_EMAIL_LIST) {
    return {
      ...state,
      ...{ summery: { ...state.summery, userstext: action.payload } }
    }
  }

  if (action.type === CLEAR_SUMMERY_COURSES) {
    return {
      ...state,
      ...{ summery: { ...state.summery, courses: action.payload } }
    }
  }

  if (action.type === ACCESS_TOKEN) {
    return {
      ...state,
      ...{ access_token: action.payload }
    }
  }

  if (action.type === UPDATE_CSV_ACTION) {
    return {
      ...state,
      ...{ csvActionType: action.payload }
    }
  }

  if (action.type === LOAD_SECTION_DATA_SUCCESS) {
    return {
      ...state,
      ...{
        courseSection: {
          data: [...state.courseSection.data.concat(action.payload)],
          loading: false
        }
      }
    }
  }

  if (action.type === UPDATE_SECTION_USER_DATA) {
    let oldArr = state.courseSection.data.filter((data) => data[action.key])

    console.log(oldArr)

    console.log(action.key)

    let mergeArr = []

    if (oldArr.length !== 0) {
      let oldState = state.courseSectionUserData.data.filter(
        (data) => !data[action.key]
      )

      console.log(oldState)

      mergeArr = [...oldState, action.payload]

      console.log(mergeArr, 'merge to old')
    } else {
      mergeArr = [...state.courseSectionUserData.data.concat(action.payload)]
    }

    return {
      ...state,
      ...{ courseSectionUserData: { data: mergeArr } }
    }
  }

  // if (action.type === LOAD_SECTION_DATA) {
  //   return {
  //     ...state,
  //     ...{ courseSection: { data: [],  loading: true } }
  //   };
  // }

  return state
}

export default CourseLevelAdmin
